import React from 'react';

import { BasicAutoMarginWrapper } from './template.styles';
import { JRCBasicAutoMarginContainerProps } from './template.type';

const BasicAutoMarginContainer = (
    { children, ...props }: JRCBasicAutoMarginContainerProps,
    ref: React.ForwardedRef<HTMLDivElement>,
) => {
    return (
        <BasicAutoMarginWrapper ref={ref} {...props}>
            {children}
        </BasicAutoMarginWrapper>
    );
};

export const JRCBasicAutoMarginContainer = React.forwardRef(BasicAutoMarginContainer);
